<template>
  <div>
    <h3>Personal Information</h3>

    <Dropdown
      v-show="show_job_title == true"
      @enter="next"
      :inputField="inputs.title"
      inputName="Your Job Title"
      inputType="string"
      :options="titleOptions"
    />
    <Input
      @enter="next"
      :inputField="inputs.ownership"
      inputName="Ownership Percentage"
      inputType="percent"
      :range="[1, 100]"
      :icons="{ right: 'fa-percent' }"
    />
    <Dropdown
      @enter="next"
      :inputField="inputs.contact_method"
      inputName="Preferred Method of Contact"
      inputType="string"
      :options="contact_method_options"
    />
    <!-- <hr /> -->
    <!-- <Input @enter="next" :inputField="inputs.refer" :inputName=tags.BASIC_INFO_REFER inputType="string" /> -->
    <Dropdown
      @enter="next"
      :inputField="inputs.refer"
      :inputName="tags.BASIC_INFO_REFER"
      inputType="string"
      :options="referOptions"
    />
    <Input
      v-show="other_selected == true"
      :inputField="inputs.other_referrer"
      :inputName="tags.BASIC_INFO_OTHER_REFERRER"
      inputType="string"
      @enter="next"
    />
    <br />
    <div class="buttons is-right">
      <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
      <a class="button is-link padded-button next-button" @click="next"
        >Continue</a
      >
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import Dropdown from "@/components/shared/Dropdown";
import ApplyPage from "@/components/shared/ApplyPage";
import CONSTANTS from "@/tools/translations.js";
function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export default {
  name: "PersonalInfoApply",
  components: {
    Input,
    Dropdown,
  },
  props: {
    toggle_job_title: Boolean,
  },
  mixins: [ApplyPage],
  created() {
    this.language = "en";
    if (this.$route.params.language) {
      this.language = this.$route.params.language;
    }
    var tags = [];
    var language = this.language;
    $.each(CONSTANTS, function (key, value) {
      var translation = value[language];
      tags[key] = value[language];
    });

    this.tags = tags;
  },
  data() {
    return {
      obj: "pg",
      inputs: {
        fn: Input.model(),
        ln: Input.model(),
        title: Input.model(),
        ownership: Input.model(),
        
        contact_method: Input.model(),
        refer: Input.model(),
        other_referrer: Input.model(),
      },
      titleOptions: [
        "Administrator",
        "CEO",
        "COO",
        "Co-Owner",
        "Director",
        "Founder",
        "General Manager",
        "Owner",
        "Manager",
        "Managing Member",
        "Member",
        "President",
        "Partner",
        "Other",
      ],
      referOptions: [
        "Bing",
        "Cardiff Representative",
        "Elevator Funding",
        "Facebook",
        "Google",
        "Instagram",
        "Podcast",
        "Spotify",
        "TikTok",
        "Youtube",
        "Other",
      ],
      contact_method_options: ["SMS", "Email", "Call"],
      other_selected: true,
      show_job_title: false,
    };
  },
  mounted: function () {
    let selected_classification = getWithExpiry("classification");
    if (selected_classification === "Sole Proprietorship") {
      this.inputs.title.value = "Owner";
    } else if (selected_classification === "Partnership") {
      this.inputs.title.value = "Partner";
    } else if (selected_classification === "LLC") {
      this.inputs.title.value = "Managing Member";
    } else if (
      selected_classification === "C Corporation" ||
      selected_classification === "S Corporation"
    ) {
      this.inputs.title.value = "President";
    } else {
      this.inputs.title.value = "Owner";
    }
    this.show_job_title = false;
    if (this.toggle_job_title) {
      this.show_job_title = this.toggle_job_title;
    }

    this.other_selected = false;
  },
  watch: {
    inputs: {
      deep: true,
      handler(newValue, oldvalue) {
        // console.log("new value: ");
        // console.log(newValue.refer.value);

        if (newValue.refer.value == "Other") {
          this.other_selected = true;
          // this.inputs.other_referrer.value = "";
        } else {
          this.other_selected = false;
          this.inputs.other_referrer.value = "  ";
        }
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.disclosure_radio {
  font-size: 0.76470588rem;
  line-height: 1.25;
  display: block;
}
input[type="radio"] {
  /* transform: scale(2);  */
  width: 16px;
  height: 16px;
  outline: gray;
}
.form-control {
  /* font-family: system-ui, sans-serif;
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.1; */
  display: grid;
  grid-template-columns: 1em auto;
  gap: 8px;
}
</style>
